// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1NbU3","label":"Radio_label__3fUT3","checkMark":"Radio_checkMark__efHDI","disabled":"Radio_disabled__1MK7D"};